import { render } from "./Button.vue?vue&type=template&id=8c0826ec&scoped=true&lang=pug&bindings={\"color\":\"props\",\"loading\":\"props\",\"disabled\":\"props\",\"className\":\"setup\"}"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=8c0826ec&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-8c0826ec"

export default script